<template>
  <v-dialog v-model="show" max-width="800px" transition="dialog-bottom-transition" persistent>
    <v-card class="pt-4 pb-6 px-10">
      <v-card-title class="mb-2"><h3>E-Mail Adressen angeben</h3></v-card-title>
      <v-container>
        <v-row class="mx-2">
          <v-col class="align-center justify-space-between" cols="12">
            <v-row align="center" class="mr-0">
              <v-combobox
                  v-model="selectedEmails"
                  chips
                  clearable
                  multiple
                  append-icon=""
                  prepend-icon="mail"
                  autofocus
                  class="selected-emails"
                >
                    <template v-slot:selection="{ attrs, item, select, selected }">
                        <v-chip
                          small
                          v-bind="attrs"
                          :input-value="selected"
                          close
                          @click="select"
                          @click:close="remove(item)"
                          :color="item.isValid == true ? 'gray_5':'red'"
                          :outlined="!item.isValid"
                          >
                          <v-icon v-if="item.isValid" small color="gray_3">mail</v-icon>
                          &nbsp;{{ item.text }}
                        </v-chip>
                    </template>
                </v-combobox>
                <p class="error_custom" v-if="error.length != 0">{{ error }}</p>
              <!-- <p v-if="users.length == 0" >Es sind keine Nutzer zum versenden dieser Umfrage verfügbar. Dies kann zwei Gründe haben:
                Entweder haben Sie die Umfrage bereits an die Nutzer gesendet oder es existieren keine Nutzer.
              </p>
              <multi-select-list :options="users" :selectedOptions="this.selectedUsers"/> -->
            </v-row>
          </v-col>

          <!-- <v-layout row wrap>
              <v-menu
                v-model="fromDateMenu"
                min-width="auto"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    label="Deadline(optional)"
                    prepend-icon="event"
                    readonly
                    :value="formatDate"
                    v-on="on"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker
                  locale="de"
                  :min="minDate"
                  v-model="dateVal"
                  no-title
                  format="MM/DD/yyyy"
                  @input="fromDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-layout> -->
        </v-row>
        <!-- <v-row v-if="integrationAvailable">
          <v-switch
              v-model="sendWithIntegration"
              label="An externe Schnittstelle senden"
              class="mt-4"
          ></v-switch>
        </v-row> -->
      </v-container>
      <v-card-actions>
        <v-btn id="leftButton" text @click.stop="close()">Abbrechen</v-btn>
        <v-btn id="rightButton" :disabled="error != '' || selectedEmails.length < 1" @click.stop="sendSurvey()" elevation="0"
               color="primary">Senden</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import pxSurveyService from "./px-survey-service.js";
import MultiSelectList from '@/components/common/MultiSelectList.vue';
import externalWFMSsurveyService from "@/components/externalWFMSsurveyService.js"
import clientService from "@/components/clientService"
import moment from "moment";

export default {
  components:{
    MultiSelectList
  },
  props: {
    value: Boolean,
    surveyId: {
      required: true,
      type: String
    },
  },
  computed: {
    deadlineDate() {
      return this.dateVal;
      // format date, apply validations, etc. Example below.
      // return this.dateVal ? this.formatDate(this.dateVal) : "";
    },
    formatDate() {
        return this.dateVal
          ? moment(this.dateVal).format("DD.MM.YYYY")
          : "";
      }

  },
  data() {
    return {
      selectedEmails: [],
      error: "",
      minDate: new Date().toJSON(),
      fromDateMenu: false,
      dateVal: null,
      resolve: null,
      reject: null,
      show:false,
      integrationAvailable: false,
      sendWithIntegration: false,
      integrationURL: null
    };
  },
  watch: {
    selectedEmails: {
      handler: function (val, oldVal) {
        if(val.length == 0 || val.length == oldVal.length) {
          this.error = "";
          return;
        }

        if(!this.validateEmail(val[val.length-1])){
          this.error = "Fehlerhaftes Format einiger Mail-Adressen. Bitte prüfen Sie die Korrektheit dieser Mail-Adressen."
          this.selectedEmails[this.selectedEmails.length-1] = {text: this.selectedEmails[this.selectedEmails.length-1],isValid: false};
        }else{
          this.error = "";
          this.selectedEmails[this.selectedEmails.length-1] = {text: this.selectedEmails[this.selectedEmails.length-1],isValid: true};
        }
      },
      deep: true
    },
    show: function(show) {
      if (show) {
        this.users = [];
        /* pxSurveyService.retrieveAllUsersToSentSurvey(this.surveyId).then(allUsers => {
          allUsers.data.forEach(user => {
            let elem = {};
            elem.id = user.userId;
            elem.text = user.firstName+' '+user.lastName;
            this.users.push(elem);
          })
        
        }); */
      }
    }
  },
  methods: {
    sendSurvey() {
      if(this.selectedEmails.length == 0) this.close();
      let validatedEmails = this.selectedEmails.filter(elem => this.validateEmail(elem.text));
      this.selectedEmails = this.selectedEmails.filter(elem => !this.validateEmail(elem.text));
      this.$emit('showSnackbar', true);
      validatedEmails = validatedEmails.map(elem => elem.text);
      pxSurveyService.sendPxSurvey(validatedEmails, this.surveyId, /* this.deadlineDate, */ this.sendWithIntegration).then(res => {
        if(this.sendWithIntegration && this.integrationAvailable && this.integrationURL != null) {
          externalWFMSsurveyService.createWFMSTask(res.data[0], this.integrationURL).then(() => {
            this.deadlineDate = null;
            this.dateVal = null;
            this.sendWithIntegration = false;
            this.integrationAvailable = false;
            this.$emit("input", this.value);
            this.resolve()
          })
        }else{
          this.$emit("input", this.value);
          this.resolve()
        }
      });
      
      if(this.selectedEmails.length > 0){
        this.error = "Fehlerhaftes Format einiger Mail-Adressen. Bitte prüfen Sie die Korrektheit dieser Mail-Adressen."
      } else{
        this.close();
      }   
    },
    remove(item){
      this.selectedEmails.splice(this.selectedEmails.indexOf(item), 1);
    },
    validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    },
    close(){
      this.selectedEmails = [];
      this.error = "";
      this.show = false;
    },
    open(){
      this.show = true;
      clientService.getIntegrationData().then(res => {
        this.integrationAvailable = res.data.integrationState;
        this.integrationURL = res.data.externalURL;
      })
      return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
      
    }
  }
};
</script>
<style scoped>
:deep .v-picker__body{
    width:500px !important;
}
</style>